import {pick} from 'lodash-es'

export function getRoute(path) {
    let args = Array.prototype.slice.call(arguments, 1)
    let count = -1
    return path.replace(/:[a-zA-Z?]+/g, function (match) {
        count += 1
        return args[count] !== undefined ? args[count] : match
    })
}

export const formPagePath = (languageCode, surveyId, ...segments) =>
  '/' + [languageCode, surveyId, ...segments].join('/')

// helper function to get router parameters with proper default values
export const getParams = (props, toPick = null) => {
    // TODO: Remove catalyst ID once backend implemente

    const {
      match: {
        params: {
          commentId,
          languageCode = "en",
          parameterValue,
          surveyId,
          invitationHash,
          catalystId,
          page,
          questionId,
          discussionId,
          topicId,
          active = true,
          languages
        },
      },
    } = props;


    const params = {
      languageCode,
      surveyId,
      invitationHash,
      catalystId,
      page,
      questionId,
      discussionId,
      parameterValue,
      commentId,
      topicId,
      active,
      languages
    };

    return toPick ? pick(params, toPick) : params
}

// helper function to get graphql query variables
export const getVariables = props => ({ variables: getParams(props) })



// WEBPACK FOOTER //
// ./src/utilities/route.js